import { render, staticRenderFns } from "./wechatArtDetails.vue?vue&type=template&id=a6213350"
import script from "./wechatArtDetails.vue?vue&type=script&lang=js"
export * from "./wechatArtDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports